import { usePermanentTyreBrandOptions } from "modules/AppointmentDetails/components/VehicleTyres/hooks";

import type { DealerLocation, TyreDiscount } from "models";

export const useBrandOptions = (selectedDiscount: TyreDiscount | null, location: DealerLocation | undefined) => {
  const { data: tyreBrandOptions = [], isFetching: isFetchingBrands } = usePermanentTyreBrandOptions(location);

  if (selectedDiscount?.is_brand_discount_only && selectedDiscount.tyre_brand_discounts?.length) {
    const discountBrands = selectedDiscount.tyre_brand_discounts.reduce<string[]>((brands, discount) => {
      if (discount.active) brands.push(discount.brand.toLocaleLowerCase());
      return brands;
    }, []);

    return { tyreBrandOptions: tyreBrandOptions.filter(bo => discountBrands.includes(bo.value)), isFetchingBrands };
  }

  return { tyreBrandOptions, isFetchingBrands };
};
